module.exports = __webpack_public_path__ + "static/media/comment-question-outline.bab0b5bf.svg";